import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import { isOnOnboardingView } from 'v3/helpers/RouteHelper';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const ONBOARDING_STEPS = ['account_details', 'enrichment', 'inbox_setup'];
const routes = [
  ...dashboard.routes,
  { path: '/:pathMatch(.*)*', component: { template: '<div></div>' } },
];

const onboardingPath = step =>
  step === 'inbox_setup' ? 'onboarding/inbox-setup' : 'onboarding';

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = async (
  to,
  routeStore = store
) => {
  const { isLoggedIn, getCurrentUser: user } = routeStore.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return false;
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return undefined;
    }
    return frontendURL('no-accounts');
  }

  const routeAccountId = Number(to.params?.accountId || accountId);
  const userAccount = accounts.find(a => a.id === routeAccountId);
  const isAdmin = userAccount?.role === 'administrator';
  const isActive = userAccount?.status === 'active';
  const needsOnboarding =
    ONBOARDING_STEPS.includes(userAccount?.onboarding_step) &&
    isAdmin &&
    isActive;

  if (to.name === 'no_accounts' || !to.name) {
    const target = needsOnboarding
      ? onboardingPath(userAccount?.onboarding_step)
      : 'dashboard';
    return frontendURL(`accounts/${routeAccountId}/${target}`);
  }

  if (needsOnboarding && !isOnOnboardingView(to)) {
    return frontendURL(
      `accounts/${routeAccountId}/${onboardingPath(userAccount?.onboarding_step)}`
    );
  }
  if (!needsOnboarding && isOnOnboardingView(to)) {
    return frontendURL(`accounts/${routeAccountId}/dashboard`);
  }

  const nextRoute = validateLoggedInRoutes(to, user, routeStore);
  return nextRoute ? frontendURL(nextRoute) : undefined;
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async to => {
    // GA4 does not automatically observe Vue SPA navigation. Deliberately send
    // only the route path: query params can contain contact or OAuth data.
    if (window.gtag && window.lumeratecGoogleAnalytics?.measurementId) {
      window.gtag('event', 'page_view', {
        page_location: `${window.location.origin}${to.path}`,
        page_path: to.path,
        page_title: document.title,
      });
    }

    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    await userAuthentication;
    return validateAuthenticateRoutePermission(to, store);
  });
};

export default router;
